export const IS_DEV = process.env.REACT_APP_BUILD_TYPE === 'development'
export const BASE_URL = process.env.REACT_APP_BASE_URL || ''
export const WS_URL = process.env.REACT_APP_WS_URL || ''
export const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || ''
